import { NgClass, UpperCasePipe } from '@angular/common';
import { Component, inject, input, OnInit, output } from '@angular/core';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { FireflyFormattingModule, FireflySuggesterModule } from '@capital-access/firefly/components';
import { COMMON_COMPONENTS_LOCALIZATION_SCOPE } from '../../common-components.const';
import { SavedFilterType } from './models/saved-filter-type.model';
import { CriteriaNamesItem } from './models/saved-filters.model';
import { SavedFiltersSingleSuggesterStore } from './saved-filters-single-suggester.store';

@Component({
  selector: 'ca-saved-filters',
  standalone: true,
  imports: [CommonLocalizationModule, FireflySuggesterModule, NgClass, UpperCasePipe, FireflyFormattingModule],
  templateUrl: './saved-filters.component.html',
  providers: [SavedFiltersSingleSuggesterStore]
})
export class SavedFiltersComponent implements OnInit {
  localizationScope = COMMON_COMPONENTS_LOCALIZATION_SCOPE;
  readonly suggesterStore = inject(SavedFiltersSingleSuggesterStore);
  filterType = input.required<SavedFilterType>();
  onSelectedSavedFilter = output<CriteriaNamesItem | null>();

  ngOnInit(): void {
    this.suggesterStore.setInitialData(this.filterType());
  }

  onSelect(item: unknown) {
    const selectedFilter = item as CriteriaNamesItem;
    this.onValueChange(selectedFilter);
  }

  onReset() {
    this.onValueChange(null);
  }

  private onValueChange(selectedFilter: CriteriaNamesItem | null): void {
    this.suggesterStore.setSelectedFilter(selectedFilter);
    this.onSelectedSavedFilter.emit(selectedFilter);
  }
}
